<template>
  <main class="main mobile_apply_form_detail" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="mobile_estimate_info">
        <div class="m_e_title">가입(약속) 내역</div>
        <div class="m_e_con">
          <div class="con_txt btmb">
            <dl class="mb04">
              <dt class="txt_1">매장명</dt>
              <dd class="txt_2">
                {{ shop.name }}
              </dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">전화 번호</dt>
              <dd class="txt_2">{{ shop.telNumber }}</dd>
            </dl>
            <dl>
              <dt class="txt_1">주소</dt>
              <dd class="txt_2">{{ getAddress(shop.address) }}</dd>
            </dl>
          </div>
          <div class="con_txt btmb">
            <dl class="mb04">
              <dt class="txt_1">신청일</dt>
              <dd class="txt_2">{{ applyDate }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">개통구분</dt>
              <dd class="txt_2" v-if="mobileEstimateDetail.joinType == 'NEW'">
                신규
              </dd>
              <dd
                class="txt_2"
                v-else-if="mobileEstimateDetail.joinType == 'CHANGE'"
              >
                기기변경
              </dd>
              <dd
                class="txt_2"
                v-else-if="mobileEstimateDetail.joinType == 'MNP'"
              >
                번호이동
              </dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">할인유형</dt>
              <dd
                class="txt_2"
                v-if="mobileEstimateDetail.payType == 'SUPPORT'"
              >
                공시지원
              </dd>
              <dd
                class="txt_2"
                v-else-if="mobileEstimateDetail.payType == 'PLAN'"
              >
                선택약정
              </dd>
            </dl>
            <dl>
              <dt class="txt_1">통신사</dt>
              <dd class="txt_2">
                {{ mobileEstimateDetail.joinPlanInfo.telecomName }}
              </dd>
            </dl>
          </div>
          <div class="con_txt btmb">
            <dl class="mb04 sb">
              <dt class="txt_1">휴대폰모델</dt>
              <dd class="txt_2">
                {{ mobileRequestView.modelName }}<br />({{
                  mobileRequestView.deviceName
                }})
              </dd>
            </dl>
            <dl class="mb04 sb">
              <dt class="txt_1">출고가</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.factoryPrice) }}원
              </dd>
            </dl>
            <dl
              class="mb04 sb"
              v-if="mobileEstimateDetail.payType == 'SUPPORT'"
            >
              <dt class="txt_1">공시지원금</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.supportMoney) }}원
              </dd>
            </dl>
            <dl
              class="mb04 sb"
              v-if="
                mobileEstimateDetail.payType == 'SUPPORT' &&
                  mobileEstimateDetail.joinType == 'MNP'
              "
            >
              <dt class="txt_1">전환지원금</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.supportMoneyMnp) }}원
              </dd>
            </dl>
            <dl class="mb04 sb">
              <dt class="txt_1">매장지원금</dt>
              <dd class="txt_2 brd">
                {{ toCurrency(mobileEstimateDetail.storeSupportMoney) }}원
              </dd>
            </dl>
            <dl class="sb">
              <dt class="txt_1">구입가(할부원금)</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.principal) }}원
              </dd>
            </dl>
          </div>
          <div class="con_txt">
            <dl class="mb04 sb">
              <dt class="txt_1">가입요금제</dt>
              <dd class="txt_2">{{ mobileEstimateDetail.joinPlanName }}</dd>
            </dl>
            <dl class="mb04 sb">
              <dt class="txt_1">월 정액</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.joinPlanPrice) }}원
              </dd>
            </dl>
            <dl class="mb04 sb" v-if="mobileEstimateDetail.payType == 'PLAN'">
              <dt class="txt_1">선택약정할인</dt>
              <dd class="txt_2 brd">
                -{{ toCurrency(mobileEstimateDetail.joinPlanDcMoney) }}원
              </dd>
            </dl>
            <dl class="sb" v-if="mobileEstimateDetail.payType == 'PLAN'">
              <dt class="txt_1">월 요금</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.joinMonthlyRate) }}원
              </dd>
            </dl>
          </div>
          <div
            class="con_txt_sub"
            v-if="
              (mobileEstimateDetail.joinPlanInfo.telecomId == 'SKT' ||
                mobileEstimateDetail.joinPlanInfo.telecomId == 'KT' ||
                mobileEstimateDetail.joinPlanInfo.telecomId == 'LGUPLUS') &&
                mobileEstimateDetail.networkType != ''
            "
            v-html="getJoinPlanTxt(mobileEstimateDetail)"
          ></div>
          <div id="more_info" class="more_info">
            <div class="con_txt">
              <div class="con_txt_box">
                <dl class="mb08 sb">
                  <dt class="txt_1 cbb">월 납부금액</dt>
                  <dd class="txt_2 brd">
                    {{ toCurrency(mobileEstimateDetail.joinTotalPrice) }}원
                  </dd>
                </dl>
                <dl class="mb08 sb">
                  <dt class="txt_1">월 단말할부금(할부이자 포함)</dt>
                  <dd class="txt_2">
                    {{ toCurrency(mobileEstimateDetail.monthlyInstallment) }}원
                  </dd>
                </dl>
                <dl class="mb08 sb">
                  <dt class="txt_1">월 요금</dt>
                  <dd class="txt_2">
                    {{ toCurrency(mobileEstimateDetail.joinMonthlyRate) }}원
                  </dd>
                </dl>
                <div class="box_txt_1">
                  ※ <span>결합할인, 복지할인, 제휴카드할인</span> 등 별도 할인
                  미포함
                </div>
              </div>
            </div>
            <div class="con_txt btmb">
              <div class="con_txt_title mb04">
                부가서비스/휴대폰보험 의무사용
              </div>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName1">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName1 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice1) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty1 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName2">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName2 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice2) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty2 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName3">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName3 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice3) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty3 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName4">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName4 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice4) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty4 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName5">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName5 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice5) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty5 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.insuranceName">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.insuranceName }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.insurancePrice) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.insuranceName }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
            </div>
            <div class="con_txt_sub mt16">
              ※ 유심비는 별도 청구될 수 있습니다.
            </div>
            <div
              class="con_txt"
              v-if="mobileEstimateDetail.giftItem || mobileEstimateDetail.info"
            >
              <div class="con_txt_box">
                <div class="box_txt_2">
                  <div
                    class="txt_1"
                    :class="{ pbb: mobileEstimateDetail.info }"
                    v-if="mobileEstimateDetail.giftItem"
                  >
                    사은품: {{ mobileEstimateDetail.giftItem }}
                  </div>
                  <div
                    class="txt_2"
                    :class="{ pt: mobileEstimateDetail.giftItem }"
                    v-if="mobileEstimateDetail.info"
                    v-html="$options.filters.nl2br(mobileEstimateDetail.info)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="more_btm" @click="showDetailView()">
            <button class="btn_detail" id="btn_detail">
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <div class="mobile_apply_form">
        <div class="af_title">
          <div class="txt_1">고객 가입 정보 (고객님 직접 입력)</div>
          <div class="txt_2"><span class="aster">*</span>필수 입력</div>
        </div>
        <div class="af_con">
          <div class="af_box">
            <!-- 개인정보 -->
            <ul>
              <div class="box_title">개인정보</div>
              <li>
                <dl>
                  <dt>이름 (본명)<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="name"
                        maxlength="10"
                        v-model.trim="form.name"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.name.$error }">
                  이름을 입력해 주세요
                </p>
              </li>
              <li>
                <dl>
                  <dt>
                    주민번호 앞 6자리<span class="aster">*</span
                    ><span class="sub_txt"> (숫자만 입력)</span>
                  </dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="residentNumber"
                        placeholder="숫자만 입력"
                        maxlength="6"
                        v-model.trim="form.residentNumber"
                        @input="handleNumberInput('residentNumber')"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.residentNumber.$error }">
                  {{ errorMessage.residentNumber }}
                </p>
              </li>
              <li v-if="mobileEstimateDetail.joinType != 'NEW'">
                <dl>
                  <dt>현재 이용중인 통신사<span class="aster">*</span></dt>
                  <dd>
                    <div class="radio_box">
                      <div
                        class="radio"
                        v-for="(item, index) in currentTelecomFilter"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :id="`currentTelecomId_${index}`"
                          v-model="form.currentTelecomId"
                          :value="item.telecomId"
                        />
                        <label :for="`currentTelecomId_${index}`">{{
                          item.telecomName
                        }}</label>
                      </div>
                    </div>
                  </dd>
                </dl>
                <p
                  class="valid"
                  :class="{ on: $v.form.currentTelecomId.$error }"
                >
                  {{ errorMessage.currentTelecomId }}
                </p>
              </li>
              <li v-if="mobileEstimateDetail.joinType == 'NEW'">
                <dl>
                  <dt>
                    개통을 원하는 휴대폰번호 뒷자리<span class="aster">*</span
                    ><span class="sub_txt"> (4자리)</span>
                  </dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="mobileNumber"
                        placeholder="숫자만 입력"
                        maxlength="4"
                        v-model.trim="form.mobileNumber"
                        @input="handleNumberInput('mobileNumber')"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.mobileNumber.$error }">
                  {{ errorMessage.mobileNumber }}
                </p>
              </li>
              <li v-else>
                <dl>
                  <dt>
                    개통할 휴대폰번호<span class="aster">*</span
                    ><span class="sub_txt"> (숫자만 입력)</span>
                  </dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="mobileNumber"
                        placeholder="숫자만 입력"
                        maxlength="11"
                        v-model.trim="form.mobileNumber"
                        @input="handleNumberInput('mobileNumber')"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.mobileNumber.$error }">
                  {{ errorMessage.mobileNumber }}
                </p>
              </li>
              <li>
                <dl>
                  <dt>주소<span class="aster">*</span></dt>
                  <dd>
                    <div class="address">
                      <label class="input">
                        <textarea
                          style="color: black"
                          :style="{
                            padding: form.address ? '0.8rem 1rem' : '0',
                          }"
                          id="address"
                          ref="address"
                          readonly="false"
                          v-model="form.address"
                          :rows="form.address ? 1 : 2"
                        />
                      </label>
                      <button @click="addressSearch">
                        주소검색
                      </button>
                    </div>
                  </dd>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        placeholder="상세주소"
                        maxlength="50"
                        v-model.trim="form.addressDetail"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.address.$error }">
                  주소를 입력해 주세요
                </p>
              </li>
              <li>
                <dl>
                  <dt>이메일<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="email"
                        placeholder="예) perce@perce.kr"
                        maxlength="50"
                        v-model.trim="form.email"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.email.$error }">
                  {{ errorMessage.email }}
                </p>
              </li>
            </ul>

            <div class="sec_bar"></div>

            <!-- 요금납부 정보 -->
            <ul>
              <div class="box_title">
                요금납부 정보 (자동이체)
                <div class="box_title_sub">
                  휴대폰명의자와 납부자가 일치해야 합니다. 개통 후에는
                  고객센터를 통해 납부자를 변경할 수 있습니다.
                </div>
              </div>

              <div class="radio_box2">
                <div class="radio">
                  <input
                    type="radio"
                    id="payType_1"
                    v-model="payType"
                    value="BANK"
                  />
                  <label for="payType_1">계좌 이체</label>
                </div>
                <div class="radio">
                  <input
                    type="radio"
                    id="payType_2"
                    v-model="payType"
                    value="CARD"
                  />
                  <label for="payType_2">카드 결제</label>
                </div>
              </div>
              <!-- 카드결제 -->

              <li v-if="payType === 'CARD'">
                <dl>
                  <dt>카드사<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="cardName"
                        maxlength="10"
                        v-model.trim="form.cardName"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.cardName.$error }">
                  카드사를 입력해 주세요
                </p>
              </li>
              <li v-if="payType === 'CARD'">
                <dl>
                  <dt>카드주(카드명의)<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="cardOwner"
                        maxlength="10"
                        v-model.trim="form.cardOwner"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.cardOwner.$error }">
                  {{ errorMessage.cardOwner }}
                </p>
              </li>
              <li v-if="payType === 'CARD'">
                <dl>
                  <dt>카드번호<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="cardNumber"
                        maxlength="19"
                        v-model.trim="form.cardNumber"
                        @input="handleCardNumber"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.cardNumber.$error }">
                  카드번호를 입력해 주세요
                </p>
              </li>
              <li v-if="payType === 'CARD'" style="margin-bottom: 2rem ">
                <dl>
                  <dt>카드 유효 기간<span class="aster">*</span></dt>
                  <dd>
                    <div class="card_box">
                      <ul class="filter">
                        <li @click="openMonthModal">
                          <div class="r_select top_mg on">
                            <button ref="cardMonth">
                              {{ form.cardMonth }}월<span class="i_drop"></span>
                            </button>
                          </div>
                        </li>
                        <li class="slash">/</li>
                        <li @click="openYearModal">
                          <div class="r_select top_mg on">
                            <button ref="cardYear">
                              {{ form.cardYear }}년<span class="i_drop"></span>
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </dd>
                </dl>
                <p
                  class="valid"
                  :class="{
                    on: $v.form.cardMonth.$error || $v.form.cardYear.$error,
                  }"
                >
                  카드 유효 기간을 입력해 주세요
                </p>
              </li>
              <!-- 계좌이체 -->
              <li v-if="payType === 'BANK'">
                <dl>
                  <dt>예금주명<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="bankOwner"
                        maxlength="10"
                        v-model.trim="form.bankOwner"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.bankOwner.$error }">
                  {{ errorMessage.bankOwner }}
                </p>
              </li>
              <li v-if="payType === 'BANK'">
                <dl>
                  <dt>은행명<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="bankName"
                        maxlength="10"
                        v-model.trim="form.bankName"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.bankName.$error }">
                  은행명을 입력해 주세요
                </p>
              </li>
              <li v-if="payType === 'BANK'">
                <dl>
                  <dt>계좌번호<span class="aster">*</span></dt>
                  <dd>
                    <label class="input">
                      <input
                        type="text"
                        ref="bankNumber"
                        placeholder="숫자만 입력"
                        maxlength="30"
                        v-model.trim="form.bankNumber"
                        @input="handleNumberInput('bankNumber')"
                      />
                    </label>
                  </dd>
                </dl>
                <p class="valid" :class="{ on: $v.form.bankNumber.$error }">
                  계좌번호를 입력해 주세요
                </p>
              </li>
            </ul>

            <div class="sec_bar"></div>

            <ul>
              <div class="box_title">본인인증방법</div>
              <li v-if="openType == 'ONLINE'">
                <div class="radio_box3">
                  <div class="radio">
                    <input
                      type="radio"
                      id="authMethod_1"
                      v-model="authMethod"
                      value="CARD"
                    />
                    <label for="authMethod_1">신용카드인증</label>
                  </div>
                  <div class="radio">
                    <input
                      type="radio"
                      id="authMethod_2"
                      v-model="authMethod"
                      value="PASS"
                    />
                    <label for="authMethod_2">PASS인증서</label>
                  </div>
                </div>
              </li>
              <li v-if="openType == 'ONLINE'">
                <div class="radio_box3">
                  <div class="radio">
                    <input
                      type="radio"
                      id="authMethod_3"
                      v-model="authMethod"
                      value="TOSS"
                    />
                    <label for="authMethod_3">TOSS인증서</label>
                  </div>
                  <div class="radio">
                    <input
                      type="radio"
                      id="authMethod_4"
                      v-model="authMethod"
                      value="NAVER"
                    />
                    <label for="authMethod_4">네이버인증서</label>
                  </div>
                </div>
              </li>
              <li v-if="openType == 'ONLINE'">
                <div class="radio_box3">
                  <div class="radio">
                    <input
                      type="radio"
                      id="authMethod_5"
                      v-model="authMethod"
                      value="CERT"
                    />
                    <label for="authMethod_5">범용공인인증서</label>
                  </div>
                </div>
              </li>
              <li v-if="openType == 'VISIT'">
                <div class="radio_box3">
                  <div class="radio">
                    <input
                      type="radio"
                      id="authMethod_1"
                      v-model="authMethod"
                      value="SCAN"
                    />
                    <label for="authMethod_1">신분증원본스캔</label>
                  </div>
                  <div class="radio">
                    <input
                      type="radio"
                      id="authMethod_2"
                      v-model="authMethod"
                      value="MOBILE"
                    />
                    <label for="authMethod_2">모바일 신분증</label>
                  </div>
                </div>

                <div class="visit_txt">
                  ※모바일 신분증 인식 오류가 있는 경우를 감안하여 신분증 원본
                  지참 바랍니다.
                </div>
              </li>
            </ul>
            <p class="btm_txt">
              ※기입된 인적사항은 보름 후 비공개됩니다.
            </p>
          </div>
          <!-- <div class="customer_join_info_blind">
            <div>고객님의 인적사항은 비공개 전환되었습니다.</div>
            <br />
            <div>내용의 확인을 원하시면</div>
            <div>고객센터로 문의를 바랍니다.</div>
          </div> -->
        </div>
      </div>

      <div class="mobile_apply_notice" v-if="this.openType == 'VISIT'">
        <div class="an_title">
          필수 안내 사항
        </div>
        <div class="an_con">
          <div class="an_box">
            ★ 매장에서 보낸 견적은 통신사 정책에 따라 수 일 혹은 수 시간 단위로
            변경될 수 있기에 가급적 빠른 시간 내에 매장에 방문하시길
            추천드립니다.
          </div>
        </div>
      </div>

      <div class="mobile_apply_agree">
        <div class="checkbox">
          <input type="checkbox" id="agree_checkbox" v-model="applyChecked" />
          <label for="agree_checkbox">개인 정보 제3자 제공에 동의합니다.</label>
        </div>
        <p class="aa_txt">
          ※기입하신 정보는 안전하게 보호되며, 해당 매장외는 공개되지 않습니다.
        </p>
      </div>
    </div>
    <div class="btm_btn">
      <div class="btn_wrap">
        <button class="btn" @click="sendForm">
          전송하기
        </button>
      </div>
    </div>
    <transition name="fade">
      <div
        class="made_toast_layer_common"
        style="position: fixed; bottom: 10%"
        v-if="isViewToast"
      >
        <div class="toast_msg">{{ message }}</div>
      </div>
    </transition>
    <AddressSearch
      ref="addressSearch"
      @close="closeAddressSearch"
    ></AddressSearch>
    <MonthModal
      ref="MonthModal"
      :show="isMonthModal"
      :month="form.cardMonth"
      @close="closeMonthModal"
    />
    <YearModal
      ref="YearModal"
      :show="isYearModal"
      :year="form.cardYear"
      @close="closeYearModal"
    />
    <DesignPopup2
      :show="applyPopup"
      :data="{
        title: '가입 신청서 전송하기',
        type: 'confirm',
        msg: `<span style='font-weight:500;font-size:1.5rem;'>매장에 신청서를 전송할까요?</span><br /><br /><span
      style='color:#757575;font-size:1.5rem;'
      >※ 신청하신 내역은 ‘신청현황' 메뉴에서<br />조회 가능하며, 삭제가 불가합니다.<br />(보름 후 자동 비공개 전환)</span
    >`,
      }"
      @close="applyPopupClose"
    />
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import { default as format } from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { required } from 'vuelidate/lib/validators';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import AddressSearch from '@common/components/modal/AddressSearch';

import DetailInfo from '@common/components/internetCommerce/DetailInfo.vue';
import MonthModal from '@common/components/modal/MonthModal';
import YearModal from '@common/components/modal/YearModal';

import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';

import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';
import { faTshirt } from '@fortawesome/free-solid-svg-icons';

export default {
  components: {
    AddressSearch,
    DesignPopup2,
    MonthModal,
    YearModal,
    // Datepicker,
  },
  data() {
    return {
      isCompleted: false,
      estimateId: 0,
      applyDate: format(new Date(), 'yyyy-MM-dd'),
      applyChecked: false,
      payType: 'BANK',
      authMethod: '',
      applyPopup: false,
      isMonthModal: false,
      isYearModal: false,
      isViewToast: false,
      message: '',
      form: {
        name: '',
        residentNumber: '',
        currentTelecomId: '',
        mobileNumber: '',
        address: '',
        addressDetail: '',
        email: '',
        bankOwner: '',
        bankName: '',
        bankNumber: '',
        cardName: '',
        cardOwner: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        authMethod: '',
      },
      errorMessage: {
        name: '',
        residentNumber: '',
        currentTelecomId: '',
        mobileNumber: '',
        address: '',
        addressDetail: '',
        email: '',
        bankOwner: '',
        bankName: '',
        bankNumber: '',
        cardName: '',
        cardOwner: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
      },
      openType: '', // VISIT, ONLINE
      currentTelecom: [
        { telecomId: 'SKT', telecomName: 'SKT' },
        { telecomId: 'KT', telecomName: 'KT' },
        { telecomId: 'LGUPLUS', telecomName: 'LGU+' },
        { telecomId: 'MVNO', telecomName: '알뜰폰' },
      ],
      currentTelecomFilter: [],
      paramsMode: '',
      planDuty: [
        { name: '0개월 (없음)', value: '0' },
        { name: '1개월', value: '1' },
        { name: '2개월', value: '2' },
        { name: '3개월', value: '3' },
        { name: '4개월', value: '4' },
        { name: '5개월', value: '5' },
        { name: '6개월', value: '6' },
        { name: '0개월 (없음)', value: '0M' },
        { name: '1개월', value: '1M' },
        { name: '2개월', value: '2M' },
        { name: '3개월', value: '3M' },
        { name: '4개월', value: '4M' },
        { name: '5개월', value: '5M' },
        { name: '6개월', value: '6M' },
        { name: 'D+93일', value: 'D+93' },
        { name: 'D+95일', value: 'D+95' },
        { name: 'D+123일', value: 'D+123' },
        { name: 'D+125일', value: 'D+125' },
        { name: 'M+3개월', value: 'M+3' },
        { name: 'M+4개월', value: 'M+4' },
        { name: 'M+6개월', value: 'M+6' },
      ],
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  async created() {
    console.log('this.$route.params');
    console.log(this.$route.params);

    this.paramsMode = this.$route.params.mode;

    if (!this.paramsMode) {
      this.$router.go(-1);
      return;
    }

    this.estimateId = this.$route.params.estimateId;

    this.openType = this.$route.params.openType;

    if (!this.estimateId) {
      this.$router.go(-1);
      return;
    }

    if (this.openType == 'VISIT') {
      this.authMethod = 'SCAN';
    } else if (this.openType == 'ONLINE') {
      this.authMethod = 'CARD';
    }

    await this.getEstimateDetail();
    await this.getRequestView(this.mobileEstimateDetail.requestId);
    await this.getStore(this.mobileEstimateDetail.estimateStore.storeId);

    // 번호이동일때 같은 텔레콤은 제외
    if (this.mobileEstimateDetail.joinType == 'MNP') {
      const foundInfo = this.currentTelecom.filter(
        info =>
          info.telecomId !== this.mobileEstimateDetail.joinPlanInfo.telecomId,
      );

      this.currentTelecomFilter = foundInfo;
      this.form.currentTelecomId = this.currentTelecomFilter[0].telecomId;
    } else if (this.mobileEstimateDetail.joinType == 'CHANGE') {
      // 기기변경일때 가입할 통신사만 노출
      const foundInfo = this.currentTelecom.filter(
        info =>
          info.telecomId === this.mobileEstimateDetail.joinPlanInfo.telecomId,
      );

      this.currentTelecomFilter = foundInfo;
      this.form.currentTelecomId = this.currentTelecomFilter[0].telecomId;
    } else {
      // 신규일때는 어차피 안보여서 패스
    }

    this.isCompleted = true;
  },
  updated() {},
  computed: {
    ...shopMapGetters({
      shop: shopTypes.SHOP,
    }),
    ...mobileMapGetters({
      mobileRequestView: mobileTypes.MOBILE_REQUEST_VIEW,
      mobileEstimateDetail: mobileTypes.MOBILE_ESTIMATE_DETAIL,
    }),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
  },
  methods: {
    ...shopMapActions([shopTypes.FETCH_SHOP]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_REQUEST_VIEW,
      mobileTypes.SELECT_MOBILE_ESTIMATE_DETAIL,
      mobileTypes.CREATE_MOBILE_APPLY_ONLINE,
      mobileTypes.CREATE_MOBILE_APPLY_VISIT,
    ]),
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getJoinPlanTxt(estimate) {
      if (estimate.payType == 'SUPPORT') {
        let planPrice = 0;
        if (estimate.joinPlanInfo.telecomId == 'SKT') {
          if (estimate.networkType == '5G') {
            planPrice = '42,000';
          } else {
            // LTE
            planPrice = '20,000';
          }
        } else if (estimate.joinPlanInfo.telecomId == 'KT') {
          if (estimate.networkType == '5G') {
            planPrice = '47,000';
          } else {
            // LTE
            planPrice = '20,000';
          }
        } else if (estimate.joinPlanInfo.telecomId == 'LGUPLUS') {
          if (estimate.networkType == '5G') {
            planPrice = '45,000';
          } else {
            // LTE
            planPrice = '26,400';
          }
        }
        return (
          '※ 가입 후 ' +
          this.getJoinPlanDuty(estimate.joinPlanDuty) +
          ' 경과 시 <span>' +
          planPrice +
          '원 이상</span> 요금제로 변경 가능'
        );
      } else if (estimate.payType == 'PLAN') {
        return (
          '※ 가입 후 ' +
          this.getJoinPlanDuty(estimate.joinPlanDuty) +
          ' 경과 시 요금제 변경 가능'
        );
      } else {
        return '';
      }
    },
    getJoinPlanDuty(joinPlanDuty) {
      console.log(joinPlanDuty);
      const foundInfo = this.planDuty.find(info => info.value === joinPlanDuty);
      if (foundInfo == undefined) {
        return joinPlanDuty + '개월';
      }

      return foundInfo.name;
    },
    getAddress(address) {
      if (address) {
        const addr = address.split(' ');
        return addr[0] + ' ' + addr[1] + ' ' + addr[2];
      } else {
        return address;
      }
    },
    async getRequestView(id) {
      let params = {
        callPart: 'CUSTOMER',
        id: parseInt(id, 10),
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_VIEW](params);

      console.log(params);

      console.log('mobileRequestView');
      console.log(this.mobileRequestView);
    },
    async getStore(id) {
      await this[shopTypes.FETCH_SHOP]({
        id: id,
      });
      console.log(id);
      console.log('shop');
      console.log(this.shop);
    },
    async getEstimateDetail() {
      const params = {
        callPart: 'CUSTOMER',
        // requestId: parseInt(this.$route.params.requestId, 10),
        id: parseInt(this.estimateId, 10),
      };
      await this[mobileTypes.SELECT_MOBILE_ESTIMATE_DETAIL](params);

      console.log(params);
      console.log('mobileEstimateDetail');
      console.log(this.mobileEstimateDetail);
    },
    showDetailView() {
      var someElement = document.getElementById(`btn_detail`);
      someElement.classList.toggle('on');

      var infoSomeElement = document.getElementById(`more_info`);
      infoSomeElement.classList.toggle('on');
    },
    validationCheck() {
      console.log('this.$v');
      console.log(this.$v);
      this.$v.$touch(); // validate 라이브러리 사용 https://yeongseungjeong.tistory.com/62
      const validKeys = Object.keys(this.$v.form);
      let isStop = false;
      isStop = true;
      validKeys.forEach(item => {
        if (this.$v.form[item].$error && isStop) {
          this.$refs[item].focus();
          isStop = false;
        }
      });
      return isStop;
    },
    async sendForm() {
      const valid = this.validationCheck();
      if (!valid) return;
      // 동의 확인
      if (!this.applyChecked) {
        this.message = '개인정보 제공 동의가 필요합니다.';
        this.toastView();
        return;
      }

      console.log('sendForm');
      console.log(this.form);

      this.applyPopup = true;
    },
    async applyPopupClose(checked) {
      if (checked) {
        let params = { ...this.form };

        params.paymentMethod = this.payType;
        params.authMethod = this.authMethod;
        params.estimateId = this.estimateId;

        // 값 초기화
        if (this.payType === 'CARD') {
          params.bankOwner = '';
          params.bankName = '';
          params.bankNumber = '';
        } else {
          params.cardName = '';
          params.cardOwner = '';
          params.cardNumber = '';
          params.cardYear = '';
        }

        params.isSendChatMessage = true;

        console.log('applyPopupClose_params');
        console.log(params);
        // 비대면
        if (this.openType == 'ONLINE') {
          console.log('ONLINE');
          await this[mobileTypes.CREATE_MOBILE_APPLY_ONLINE](params);
        } else if (this.openType == 'VISIT') {
          // 매장방문
          await this[mobileTypes.CREATE_MOBILE_APPLY_VISIT](params);
        }
      }

      this.$router.go(-1);

      this.applyPopup = false;
    },
    addressSearch() {
      this.$refs.addressSearch.isOpen = true;
      this.$refs.addressSearch.list = [];
      this.$refs.addressSearch.direction = 'top';
      this.$refs.addressSearch.infiniteId = 0;
      this.$refs.addressSearch.searchText = '';
      this.$refs.addressSearch.searchResultText = '';
      this.$router.push({
        name: 'Mobile.ApplyForm',
        params: this.$route.params,
        hash: '#address',
      });
    },
    async closeAddressSearch() {
      await this.$refs.addressSearch.$refs.dummy2.scrollIntoView({
        behavior: 'smooth',
      });

      this.jibunAddr = this.$refs.addressSearch.jibunAddr;
      this.form.address = this.$refs.addressSearch.roadAddr;
      this.$refs.addressSearch.isOpen = false;

      this.handelTextareaHeight();

      await util.sleep(100);

      this.$router.go(-1);
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    openMonthModal() {
      this.isMonthModal = true;
    },
    closeMonthModal(dataType, val) {
      if (dataType) {
        this.form.cardMonth = val;
      }
      this.isMonthModal = false;
    },
    openYearModal() {
      this.isYearModal = true;
    },
    closeYearModal(dataType, val) {
      if (dataType) {
        this.form.cardYear = val;
      }
      this.isYearModal = false;
    },
    handleCardNumber(evt) {
      this.form.cardNumber = util.cardNumberFormatter(
        evt.data,
        evt.target.value,
      );
    },
    handleNumberInput(value) {
      this.form[value] = util.numberFormatter(this.form[value]);
    },
    handelTextareaHeight() {
      const textarea = this.$refs.address;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 2 + 'px';
    },
    customerApplyCancelPopupOpen() {
      this.customerApplyCancelPopup = true;
    },
    customerApplyCancelPopupClose(checked) {
      if (checked) {
        this.setUserApplyCancel(this.applyId);
      }
      this.customerApplyCancelPopup = false;
    },
  },
  validations: {
    form: {
      name: { required },
      residentNumber: {
        test(val) {
          val = val.trim();
          if (!val) {
            this.errorMessage.residentNumber =
              '주민번호 앞자리를 입력해 주세요';
            return false;
          }
          const regex = /^([0-9]{6})$/;
          if (!regex.test(val)) {
            this.errorMessage.residentNumber =
              '주민번호(6자리) 앞자리를 확인해 주세요';
            return false;
          }
          return true;
        },
      },
      mobileNumber: {
        test(val) {
          val = val.trim();
          if (!val) {
            if (this.mobileEstimateDetail.joinType == 'NEW') {
              this.errorMessage.mobileNumber =
                '휴대폰 번호 뒷자리를 입력해 주세요';
            } else {
              this.errorMessage.mobileNumber = '휴대폰 번호를 입력해 주세요';
            }
            return false;
          }

          if (this.mobileEstimateDetail.joinType == 'NEW') {
            const regex = /^\d{4}$/;
            if (!regex.test(val) || val.length != 4) {
              this.errorMessage.mobileNumber =
                '휴대폰 번호 뒷자리를 정확히 입력해 주세요';
              return false;
            }
          } else {
            const regex = /^010|011|016|017|018|019|999\d{3,4}\d{4}$/;
            if (!regex.test(val) || (val.length != 10 && val.length != 11)) {
              this.errorMessage.mobileNumber =
                '휴대폰 번호를 정확히 입력해 주세요';
              return false;
            }
          }
          return true;
        },
      },
      address: { required },
      email: {
        test(val) {
          if (!val) {
            this.errorMessage.email = '이메일을 확인해 주세요';
            return false;
          }

          if (val && !util.emailFormatter(val)) {
            this.errorMessage.email = '이메일을 확인해 주세요';
            return false;
          }
          return true;
        },
      },
      cardName: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      cardOwner: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            this.errorMessage.cardOwner = '카드주명을 입력해 주세요';
            return false;
          }
          if (this.payType === 'CARD' && val != this.form.name) {
            this.errorMessage.cardOwner =
              '휴대폰 명의자와 납부자가 일치해야 합니다';
            return false;
          }
          return true;
        },
      },
      cardNumber: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      cardMonth: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      cardYear: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      bankOwner: {
        test(val) {
          if (this.payType === 'BANK' && !val) {
            this.errorMessage.bankOwner = '예금주명을 입력해 주세요';
            return false;
          }

          if (this.payType === 'BANK' && val != this.form.name) {
            this.errorMessage.bankOwner =
              '휴대폰 명의자와 납부자가 일치해야 합니다';
            return false;
          }
          return true;
        },
      },
      bankName: {
        test(val) {
          if (this.payType === 'BANK' && !val) {
            return false;
          }
          return true;
        },
      },
      bankNumber: {
        test(val) {
          if (this.payType === 'BANK' && !val) {
            return false;
          }
          return true;
        },
      },
      currentTelecomId: {
        test(val) {
          val = val.trim();
          if (this.mobileEstimateDetail.joinType != 'NEW') {
            if (!val) {
              this.errorMessage.currentTelecomId = '통신사를 선택해 주세요';
              return false;
            }
          }
          return true;
        },
      },
      // giftOption: { required },
    },
    setDate() {
      // console.log(this.form.installDate);
      // const installDate = this.form.installDate;
      // var week = new Array(
      //   '일요일',
      //   '월요일',
      //   '화요일',
      //   '수요일',
      //   '목요일',
      //   '금요일',
      //   '토요일',
      // ); // 7, 1, 2, 3, 4, 5, 6
      // const iDate = new Date(installDate.setDate(installDate.getDate()));
      // this.form.installDate =
      //   format(iDate, 'MM월 dd일') + ' (' + week[iDate.getDay()] + ')';
      // console.log(this.form.installDate);
    },
  },
};
</script>
